import React, { useRef } from 'react';
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion';
import { images } from '../data/site';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Signature() {
  const ref = useRef<HTMLDivElement | null>(null);
  const reduce = useReducedMotion();
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], reduce ? ['0%', '0%'] : ['-8%', '8%']);
  return <section className="bg-cream" data-id="element-113" data-mp="18d2w4fhf9z3a">
      <div ref={ref} className="relative h-[62svh] min-h-[400px] w-full overflow-hidden" data-id="element-114" data-mp="18c1lgc4bjem3">
        <motion.img style={{
        y
      }} src={images.signatureWide} alt="Amandelcroissant met poedersuiker" className="absolute inset-0 h-[118%] w-full object-cover" data-id="element-115" data-mp="1m36fmyox3ep1" />
        <div className="absolute inset-0 bg-espresso/50" aria-hidden="true" data-id="element-116" data-mp="1w372uvpwqeyi" />
        <div className="relative mx-auto flex h-full max-w-6xl items-center px-6" data-id="element-117" data-mp="1r43v33ijlumu">
          <motion.blockquote initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-20%'
        }} transition={{
          duration: 0.3,
          ease: EASE
        }} className="max-w-2xl text-cream" data-id="element-118" data-mp="3b1vowoaglxep">
            <p className="text-[clamp(1.7rem,3.4vw,2.9rem)] font-medium leading-[1.15] tracking-[-0.02em]" data-id="element-119" data-mp="3p1eub9bvyunb">
              “Luxe zit in elk detail, van de eerste laag tot de laatste hap.”
            </p>
            <footer className="mt-6 text-sm text-cream/65" data-id="element-120" data-mp="2tx1or7b2upa">Aden’s Viennoiserie · Amsterdam</footer>
          </motion.blockquote>
        </div>
      </div>
    </section>;
}